import { render, staticRenderFns } from "./FluxoColocacaoVaso.vue?vue&type=template&id=9188db7a&scoped=true"
import script from "./FluxoColocacaoVaso.vue?vue&type=script&lang=js"
export * from "./FluxoColocacaoVaso.vue?vue&type=script&lang=js"
import style0 from "./FluxoColocacaoVaso.vue?vue&type=style&index=0&id=9188db7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9188db7a",
  null
  
)

export default component.exports